import type { PaymentStatus } from "@spwn/types/spwn";
import type { i18nStringType } from "i18n/i18nString";

const PAYMENT_STATUS_LABELS: Record<PaymentStatus, i18nStringType> = {
  PAYSUCCESS: "settlementHistory.paymentStatus.success",
  UNPROCESS: "settlementHistory.paymentStatus.unprocessed",
  CANCEL: "settlementHistory.paymentStatus.cancelled",
  RETURN: "settlementHistory.paymentStatus.refunded",
};

export const getPaymentStatusLabel = (
  status: PaymentStatus
): i18nStringType => {
  return PAYMENT_STATUS_LABELS[status];
};
